// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dots__wrapper[data-v-0e507f65]{position:relative;display:block;overflow:hidden}.dots__wrapper .dots__visible[data-v-0e507f65]{display:block;overflow:hidden;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;padding-bottom:2px}.dots__wrapper .dots__actual-content[data-v-0e507f65],.dots__wrapper .dots__calculate[data-v-0e507f65]{display:block;visibility:hidden;position:absolute;width:100%;top:0;left:0}", ""]);
// Exports
module.exports = exports;
